import { makeAutoObservable, runInAction } from 'mobx';
import { ExtraDustyProductsData } from 'screens/StandardTimeLegend/components/ExtraDustyProducts/extraDustyProducts.types';
import { standardTimeLegendServices } from 'services/standardTimeLegend';

export class ExtraDustyProductsStore {
  extraDustyProducts: ExtraDustyProductsData[] = [];
  isLoading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  fetchExtraDustyProducts = async () => {
    this.isLoading = true;
    try {
      const response = await standardTimeLegendServices.getExtraDustyProducts();
      runInAction(() => {
        this.extraDustyProducts = response.data;
        this.isLoading = false;
      });
    } catch (error) {
      console.log('Error fetching extra dusty products', error);
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };
}
